import { Button, ButtonGroup, Divider, FormGroup, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { IFieldProps } from "decorator-form";
import React from "react";

import DropdownSelect from "common/form/widgets/common/DropdownSelect";
import IOption from "common/models/IOption";
import { ConditionTypeRegistry } from "./ConditionTypeRegistry";
import { ICondition, IConditionType } from "./IConditionType";

export interface IConditionFieldOptions {
	types: IConditionType[];
}

interface IConditionFieldProps extends IFieldProps<ICondition> {
	depth?: number;
	options?: IConditionFieldOptions;
	preview?: boolean;
}

interface IConditionFieldState {
	preview: boolean;
}

export default class ConditionField extends React.PureComponent<IConditionFieldProps, IConditionFieldState> {

	public static withOptions(options: IConditionFieldOptions) {
		return (props: IConditionFieldProps) => <ConditionField {...props} options={options} />;
	}

	public state = { preview: true };

	public render() {
		const { children, depth = 0, formData = {} as ICondition, options = {} as IConditionFieldOptions, schema } = this.props;

		const condition = formData;

		const ct = ConditionTypeRegistry.get(condition.type);

		const field = (depth === 0 && this.state.preview ) ? ConditionTypeRegistry.preview(condition) : (
			<div>
				<div style={{display: 'flex', justifyContent: "space-between"}}>
					<div>
						<FormGroup>
							<DropdownSelect
								buttonProps={{
									minimal: true,
									small: true
								}}
								options={(options.types || []).map<IOption<string>>((t) => ({
									value: t.type,
									label: t.label,
									icon: t.icon
								}))}
								value={ct ? ct.type : undefined}
								onChange={this.onChangeField('type')}
							/>
						</FormGroup>
					</div>
					{children}
				</div>
				{ct && !!ct.renderField && ct.renderField(condition.data || {} as any, this.onChangeField('data'), options, depth)}
			</div>
		);

		if (depth < 1) {
			return (
				<FormGroup
					label={schema && schema.title}
				>
					<Divider />
					{field}
					<FormGroup>
						<ButtonGroup>
							<Button
								intent={Intent.PRIMARY}
								text={this.state.preview ? 'Edit' : 'Preview'}
								icon={this.state.preview ? IconNames.EDIT : IconNames.EYE_OPEN}
								minimal={true}
								onClick={this.togglePreview}
							/>
							{
								!!condition.type && (
									<Button
										intent={Intent.DANGER}
										small={true}
										minimal={true}
										icon={IconNames.SMALL_CROSS}
										text="Clear"
										onClick={this.onClear}
									/>
								)
							}
						</ButtonGroup>
					</FormGroup>
				</FormGroup>
			);
		}

		return field;
	}

	private togglePreview = () => this.setState({preview: !this.state.preview});

	private onChangeField = (field: keyof ICondition) => (value: any) => {
		const { depth = 0, formData, onChange } = this.props;

		// clear condition cache if making a change
		// only do the clear at the root level
		if (depth === 0) {
			ConditionTypeRegistry.clearCache();
		}

		if (field === 'type') {
			onChange(ConditionTypeRegistry.create(value));
		} else {
			onChange({
				...formData,
				data: value
			});
		}
	}

	private onClear = () => this.props.onChange(undefined);
}



// WEBPACK FOOTER //
// ./src/common/form/fields/condition/ConditionField.tsx